var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vSelect',{staticClass:"CountrySelection",attrs:{"options":_vm.countryOptions,"clearable":false,"reduce":option => option.value},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}})
}
var staticRenderFns = []

export { render, staticRenderFns }